module.exports = __webpack_public_path__ + "static/media/h-2-01.269c71f6.jpg";